
// rounting
import RegistrationHostingList from './registration-hosting-list/registration-hosting-list.vue';
import HostList from './host-list/host-list.vue';
import HostDetail from './host-detail/host-detail.vue';
import TradingRulesList from './trading-rules-list/trading-rules-list.vue';
import TradingRulesDetail from './trading-rules-detail/trading-rules-detail.vue';

export default [
  {
    path: 'list',
    name: 'RegistrationHostingList',
    component: RegistrationHostingList,
    meta: {
      title: '登记托管',
      breadCrumbShowIndexArr: [0, 1]  // 面包屑
    }
  },
  {
    path: 'hostList',
    name: 'HostList',
    component: HostList,
    meta: {
      title: '信息披露',
      breadCrumbShowIndexArr: [0, 1]  // 面包屑
    }
  },
  {
    path: 'hostDetail',
    name: 'HostDetail',
    component: HostDetail,
    meta: {
      title: '详情',
      breadCrumbShowIndexArr: [0, 1]  // 面包屑
    }
  },
  {
    path: 'trading-rules-list/:type',
    name: 'TradingRulesList',
    component: TradingRulesList,
    meta: {
      title: '登记托管信息',
      breadCrumbShowIndexArr: [0, 1]  // 面包屑
    }
  },
  {
    path: 'trading-rules-detail',
    name: 'tradingRulesDetail',
    component: TradingRulesDetail,
    meta: {
      title: '登记托管信息详情',
      breadCrumbShowIndexArr: [0, 1, 3]
    }
  }
];
